export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SET_SHARE_MODAL_STEP = 'SET_SHARE_MODAL_STEP'
export const SET_REVIEW_POST_MODAL = 'SET_REVIEW_POST_MODAL'
export const SET_SHARE_JOB_POST_MODAL = 'SET_SHARE_JOB_POST_MODAL'
export const SET_EDIT_APPLICANT_MODAL = 'SET_EDIT_APPLICANT_MODAL'
